module.exports = __webpack_public_path__ + "static/tablero-5021af48d1e01e88f12c28539dcd9206.webp";